export function formatMoney(minor, currency = 'PLN', locale = 'pl-PL') {
    if (minor === null)
        return '—';
    return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(minor / 100);
}
export function priceChangePercent(currentMinor, previousMinor) {
    if (currentMinor === null || previousMinor === null || previousMinor === 0)
        return null;
    return ((currentMinor - previousMinor) / previousMinor) * 100;
}
export function lowestOffer(offers) {
    return offers.filter((offer) => offer.currentPriceMinor !== null && offer.checkStatus === 'ok' && offer.availability !== 'out_of_stock' && offer.monitoringStatus !== 'paused' && !['uncertain', 'rejected'].includes(offer.matchStatus ?? 'verified'))
        .toSorted((left, right) => left.currentPriceMinor - right.currentPriceMinor)[0];
}
export function medianPriceMinor(history) {
    if (history.length === 0)
        return null;
    const values = history.map((point) => point.priceMinor).toSorted((a, b) => a - b);
    const middle = Math.floor(values.length / 2);
    if (values.length % 2 === 1)
        return values[middle] ?? null;
    const left = values[middle - 1];
    const right = values[middle];
    return left === undefined || right === undefined ? null : Math.round((left + right) / 2);
}
export function getOfferStats(offer) {
    const prices = offer.history.map((point) => point.priceMinor);
    const firstMinor = offer.history[0]?.priceMinor ?? offer.currentPriceMinor;
    const previousMinor = offer.history.at(-2)?.priceMinor ?? offer.previousPriceMinor;
    return {
        minMinor: prices.length ? Math.min(...prices) : offer.currentPriceMinor,
        maxMinor: prices.length ? Math.max(...prices) : offer.currentPriceMinor,
        averageMinor: prices.length ? Math.round(prices.reduce((sum, price) => sum + price, 0) / prices.length) : offer.currentPriceMinor,
        medianMinor: medianPriceMinor(offer.history) ?? offer.currentPriceMinor,
        changeFromFirstPercent: priceChangePercent(offer.currentPriceMinor, firstMinor),
        changeFromPreviousPercent: priceChangePercent(offer.currentPriceMinor, previousMinor),
    };
}
